import { render } from "./EnregistrementDossier.vue?vue&type=template&id=77a5f330"
import script from "./EnregistrementDossier.vue?vue&type=script&lang=js"
export * from "./EnregistrementDossier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/private/formulaire/EnregistrementDossier.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77a5f330"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77a5f330', __exports__)) {
    api.reload('77a5f330', __exports__)
  }
  
  module.hot.accept("./EnregistrementDossier.vue?vue&type=template&id=77a5f330", () => {
    api.rerender('77a5f330', render)
  })

}


export default __exports__